import React from "react";
import "../Services.css";
import FinancialPlanningPic from "../../resources/financial-planning.jpg"; // Ensure the image path is correct

const FinancialPlanning = () => {
  return (
    <div className="services-page-container">
      <img
        className="services-img"
        src={FinancialPlanningPic}
        alt="Future Freedom Planning"
      />
      <h1 className="services-heading">
        Future Freedom Planning: Your Roadmap to a Secure Future
      </h1>
      <p className="services-text">
        Future Freedom Planning is not just about saving money; it’s about
        making sure that you, your family, and your future are financially
        secure. Whether it’s building wealth, planning for retirement, funding
        your children’s education, or managing risks, Future Freedom Planning
        helps you take control of your financial destiny. At{" "}
        <b className="services-bold">United Investment Point</b>, we specialize
        in helping you navigate the complexities of Future Freedom Planning with
        expert guidance tailored to your personal goals.
      </p>
      <p className="services-text">
        Future Freedom Planning involves evaluating your current financial
        situation, understanding your future goals, and creating a detailed
        strategy to help you achieve those goals. At{" "}
        <b className="services-bold">United Investment Point</b>, we offer a
        comprehensive range of financial services designed to optimize your
        finances and guide you towards your objectives, whether it’s building
        wealth, saving for retirement, or preparing for the unexpected.
      </p>

      {/* <div className="video-container"> */}
      {/* <iframe */}
      {/*               width="100%" */}
      {/*               height="100%" */}
      {/*               src="https://www.youtube.com/embed/pv77fN7h4CI" // Replace with your video URL */}
      {/*               title="Finnancial Guidance Video" */}
      {/*               allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" */}
      {/*               allowFullScreen */}
      {/*           ></iframe> */}
      {/* </div> */}

      <h2 className="services-subheading">
        The Importance of Future Freedom Planning
      </h2>
      <p className="services-text">
        Many people think Future Freedom Planning is only for the wealthy or for
        those nearing retirement. However, no matter your income level, age, or
        stage in life, Future Freedom Planning is essential. Here’s why:
      </p>
      <ul className="services-text-list">
        <li>
          <b className="services-bold">Security for Your Family:</b> By planning
          your finances properly, you ensure that your loved ones are protected
          from financial hardship, especially in case of an emergency or
          unforeseen event.
        </li>
        <li>
          <b className="services-bold">Achieving Your Goals:</b> Future Freedom
          Planning helps you break down your long-term goals (like buying a
          home, sending children to college, or retiring comfortably) into
          actionable steps that you can work towards.
        </li>
        <li>
          <b className="services-bold">Retirement Readiness:</b> A solid
          financial plan includes retirement savings, ensuring that you have
          enough resources to enjoy your post-working years without financial
          stress.
        </li>
        <li>
          <b className="services-bold">Peace of Mind:</b> With a comprehensive
          financial plan in place, you’ll have the peace of mind knowing that
          you are on track to meet your goals, with strategies in place to
          handle emergencies.
        </li>
      </ul>

      <h2 className="services-subheading">
        Steps in Our Future Freedom Planning Process
      </h2>
      <p className="services-text">
        At <b className="services-bold">United Investment Point</b>, we take a
        step-by-step approach to Future Freedom Planning. Our expert team will
        work closely with you to create a plan that aligns with your financial
        goals and objectives. Here’s how we do it:
      </p>
      <ul className="services-text-list">
        <li>
          <b className="services-bold">Step 1 – Financial Assessment:</b> We
          start by reviewing your current financial situation. This includes
          analyzing your income, expenses, debts, and assets. Understanding
          where you stand financially is essential to formulating an effective
          plan.
        </li>
        <li>
          <b className="services-bold">Step 2 – Setting Goals:</b> Next, we work
          with you to define your short-term and long-term financial goals.
          Whether it’s buying a home, saving for your children’s education, or
          planning for retirement, we’ll help you articulate your financial
          objectives.
        </li>
        <li>
          <b className="services-bold">Step 3 – Strategy Development:</b> Based
          on your financial assessment and goals, we develop a tailored
          strategy. This may include budgeting, investing, insurance guidance,
          tax optimization, and retirement guidance.
        </li>
        <li>
          <b className="services-bold">Step 4 – Implementation:</b> After
          agreeing on the strategy, we implement your plan efficiently. This
          involves putting the necessary actions in place.
        </li>
        <li>
          <b className="services-bold">Step 5 – Monitoring and Adjustments:</b>{" "}
          We don’t just stop at implementation. Future Freedom Planning is an
          ongoing process. We regularly review your plan, track your progress,
          and make adjustments as needed to ensure you stay on course to meet
          your goals.
        </li>
      </ul>

      <h2 className="services-subheading">
        How United Investment Point Can Help
      </h2>
      <p className="services-text">
        At <b className="services-bold">United Investment Point</b>, we believe
        in a holistic approach to Future Freedom Planning. We offer a wide range
        of services to help you manage every aspect of your financial life:
      </p>
      <ul className="services-text-list">
        <li>
          <b className="services-bold">Investment Management:</b> We provide
          expert guidance on a wide range of investment options, helping you
          grow your wealth while minimizing risks.
        </li>
        <li>
          <b className="services-bold">Retirement Guidance:</b> Whether you’re
          just starting your career or nearing retirement, we help you plan for
          a secure and comfortable future by creating personalized retirement
          strategies that maximize your savings.
        </li>
        <li>
          <b className="services-bold">Tax Guidance:</b> Our financial experts
          assist in minimizing your tax liability through smart tax strategies,
          ensuring that more of your income goes toward your goals.
        </li>
        <li>
          <b className="services-bold">Estate Guidance:</b> We help you plan for
          the future distribution of your estate, ensuring that your assets are
          transferred according to your wishes and in the most tax-efficient
          manner.
        </li>
      </ul>

      <p className="services-text">
        Whether you’re looking to secure your financial future, grow your
        wealth, or protect your loved ones, we are here to help. Our team at{" "}
        <b className="services-bold">United Investment Point</b> will provide
        you with the knowledge and tools to make informed decisions and achieve
        your financial goals. Reach out to us today and take the first step
        toward a secure financial future.
      </p>
    </div>
  );
};

export default FinancialPlanning;
